// File name cannot contain these comma separated special chars *,/,\,:,<,>,|,?,"
// or the word "esigned"
export const SPECIAL_CHARS = /[*/\:<>|?"]|esigned/;

export function isFileNameValid(fileName?: string | null): boolean {
  return !!fileName && !SPECIAL_CHARS.test(fileName);
}
